import {Button} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface AddLayerButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export default function AddLayerButton({disabled, onClick}: AddLayerButtonProps): JSX.Element {
  return (
    <Button
      bg="white"
      ml={5}
      disabled={disabled}
      leftIcon={<BenchlingIcon icon="plus" />}
      onClick={onClick}
      size="xs"
      variant="ghost"
    >
      Add
    </Button>
  );
}
